import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as _ from "lodash";
import { PlayersService } from '../../services/players/players';
import { RdGameService } from '../../services/games/rd-game';
import { WorkCardService } from '../../services/work-card';
import { AllStatus } from '../../../core/services/status/all-status';
import { FieldBuilder } from '../../services/fields/field-builder';
import { ActivatedRoute } from '@angular/router';
import { EndGameService } from '../../services/end/end-game';
import { GameInfoService } from '../../services/games/game-info';
import { CardHictoryPlayer } from '../../services/history/card-hictory-player';
import { TranslatePipe } from '@ngx-translate/core';
import { Downtime } from '../../../core/services/times/downtime';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { GameMode } from '../../model/i-game-mode';

@Component({
  selector: 'app-dice',
  imports: [FormsModule, TranslatePipe, MatProgressBarModule],
  templateUrl: './dice.html',
  styleUrl: './dice.scss'
})
export class Dice implements OnInit {

  @Input() turning: any;
  @Input() player: any;
  @Input() typeGame: string;
  @Input() gameMode: GameMode = 'single';
  

  players = inject(PlayersService);
  activatedRoute = inject(ActivatedRoute);
  rdUse = inject(RdGameService);
  cardInfo = inject(WorkCardService);
  fieldBuilder = inject(FieldBuilder);
  public allStatus$ = inject(AllStatus);
  endGame = inject(EndGameService);
  gameInfo = inject(GameInfoService);
  cardHictory = inject(CardHictoryPlayer);
  downtime = inject(Downtime);
  
  diceValue: number = 1;
  values: Array<number> = [];
  summDice: number;
  startValue: number;

  isEighty: boolean = true;
  isGoToFinish = signal(true);

  ngOnInit(): void {
    this.allStatus$.setViewBlockDice(true);
  }

  isActive(turning: number,player_id: number){
    // if(turning === player_id && this.allStatus$.isRollDice){
    //   this.allStatus$.setExplanationTxt('');
    // }
    return turning === player_id;
  }

  private getRandomItemWeighted(weight1 = 0.8) {
    // weight1 — частка для першого масиву (0.8 = 80%)
    if (_.random(1, true) < weight1) {
        // TODO перевести поле на "Свои"
        if(!this.isEighty){
         
          this.isEighty = true;
          this.fieldBuilder.chengeListFields(this.isEighty);
        }
        //return arr1[Math.floor(Math.random() * arr1.length)];
    } else {
        //TODO перемикаємо поле на "Свободные"
       
        this.isEighty = false;
        this.fieldBuilder.chengeListFields(this.isEighty);
        //return arr2[Math.floor(Math.random() * arr2.length)];
    }
}
  
  rollTheDice(){
    if(!this.rdUse.connected() ||
      !this.rdUse.gameStateReady() ||
      !this.allStatus$.isRollDice ||
      String(this.turning) !== String(this.player?.player_id)){
      return;
    }

    this.isGoToFinish.set(false);
    if( this.typeGame === 'role' ){
      this.getRandomItemWeighted();
    }
    
    this.downtime.refreshTimer();

   // this.getRandomItemWeighted();
    this.values = [];
    let i: number = 0;
    do{
      this.values.push( _.random(1,6) ); ///  
      ++i;
    }while(i < this.diceValue);

    this.summDice = this.values.reduce((accumulator, currentValue) => accumulator + currentValue);
    this.startValue = this.summDice + (this.players.player.dice_sum as number);
    
    this.fieldСheck();


    this.players.updateDice(this.summDice);
    this.cardInfo.initial(
      this.players.player.dice_sum as number,
      this.players.player.player_id,
      this.activatedRoute.snapshot.paramMap.get('id') as string,
      this.allStatus$.isNewbie$(),
      Number(this.rdUse.game$?.turn_id ?? 0),
      this.gameMode,
    );

    // this.rdUse.saveCard(this.players.player.player_id, this.cardInfo.showCard);
    //this.allStatus$.isPassBoll = true;
    
    this.allStatus$.isRollDice = false;
    //this.allStatus$.setViewBlockDice(false);

    setTimeout(()=>{
      this.isGoToFinish.set(true);
      this.gameInfo.getGameInfo(this.activatedRoute.snapshot.paramMap.get('id') as string).subscribe((result:any)=>{
        let findData = result.room.players.find((item: any)=> item.player_id === this.players.player.player_id);
        let own: Array<number> = findData.own || [];
        this.rdUse.updateOwn(own, this.players.player.player_id);
        
        //this.allStatus$.setViewBlockDice(false);
      });
    },1000)
    
  }

  fieldСheck(){
    if(this.startValue > this.fieldBuilder.listFields.length){
      const round = Math.floor((this.startValue) / this.fieldBuilder.listFields.length);
      const newPosition = (this.startValue) - (this.fieldBuilder.listFields.length * round);        
      this.startValue = (newPosition === 0) ? this.fieldBuilder.listFields.length : newPosition;
      //this.summDice = this.summDice + newPosition;
    }
    if(this.fieldBuilder.isNotAnEmptyField(this.startValue)){
      ++this.summDice;
      ++this.startValue;
      if(this.startValue > this.fieldBuilder.listFields.length){
        this.startValue = 1;
      }
      this.fieldСheck();
    }
  }

  // passTheBoll(){

  //   this.rdUse.deleteCard();
  //   if(this.allStatus$.isEndGame){
  //     this.rdUse.dataСollection(this.allStatus$.playerEndData, this.player);
  //     this.allStatus$.isCollectionProcess = false;
  //     this.allStatus$.isEndGame = false;
  //   }
    
  //   this.rdUse.clearResponse();

  //   this.rdUse.nextTurn();
  //   this.allStatus$.clearNowCard();    
    
  //   this.allStatus$.isPassBoll = false;
  //   this.allStatus$.isRollDice = true;
  //   this.allStatus$.isNewListVariant = true;
  //   this.allStatus$.txtCardInfo = '';

  //   if( this.players.players.length === 1){
  //     this.endGame.isEndOfGame(this.player.player_id);
  //   }
    
  //   this.downtime.refreshTimer();
  // }

}
